import { render, staticRenderFns } from "./TableBank.vue?vue&type=template&id=6ade7902&"
import script from "./TableBank.vue?vue&type=script&lang=js&"
export * from "./TableBank.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports